import { rest, MockedRequest, DefaultRequestBody, RestHandler } from 'msw'
import multiCarrierQuoteResponse from './multiCarrierQuoteResponse'
import { IS_DENTAL_AND_VISION, IS_LOCAL_ENVIRONMENT } from 'core/constants/environment'
import { API_PIVOTHEALTH, BACKEND_PIVOT } from 'core/constants/endpoints'
import multiCarrierEligibilityResponse from './multiCarrierEligibilityResponse'
import eligibilityQuestionsResponse from './eligibilityQuestionsResponse'

const multiCarrierQuoteMock = rest.post(
  `${BACKEND_PIVOT}/v2/getQuote`,
  (req, res, ctx) => {
    console.log('Mocking quote response...')
    return res(ctx.json(multiCarrierQuoteResponse))
  }
)

const multiCarrierEligibilityMock = rest.get(
  `${BACKEND_PIVOT}/multi-carrier-eligibility`,
  (req, res, ctx) => {
    console.log('Mocking multi-carrier eligibility response...')
    return res(ctx.json(multiCarrierEligibilityResponse))
  }
)

const eligibilityQuestionsMock = rest.get(
  `${API_PIVOTHEALTH}/compliance/v3/questions`,
  (req, res, ctx) => {
    console.log('Mocking eligibility questions...')
    return res(ctx.json(eligibilityQuestionsResponse))
  }
)

const mswMocks: RestHandler<MockedRequest<DefaultRequestBody>>[] = []

// Only mock multi-carrier quotes if we're running locally
if (IS_LOCAL_ENVIRONMENT && !IS_DENTAL_AND_VISION) mswMocks.push(multiCarrierQuoteMock)
if (IS_LOCAL_ENVIRONMENT && !IS_DENTAL_AND_VISION)
  mswMocks.push(multiCarrierEligibilityMock)
if (IS_LOCAL_ENVIRONMENT && !IS_DENTAL_AND_VISION) mswMocks.push(eligibilityQuestionsMock)

export { mswMocks, multiCarrierQuoteMock }
